import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { projectQueryKeys } from '../constants'

export const useGetProjectLimitQuery = (options) => {
  const handleQuery = async () => {
    const { data } = await api('/api/projects/limit', {
      method: 'get'
    })

    return data
  }

  return useQuery({
    queryKey: [projectQueryKeys.GET_PROJECT_LIMIT_QUERY],
    queryFn: handleQuery,
    retry: 0,
    ...options
  })
}
